module.exports = __webpack_public_path__ + "static/media/menuActiveIndicator.5c60f116.svg";